<mat-card
  class="comment-card"
  [class.clickable]="comment.location === commentLocation.DM && !isOnDm() && !editMode"
  (click)="navigateToDu()">
  <div>
    @if (editMode) {
      <o-comment-edit (endEdit)="closeEdit()" [comment]="comment" />
    } @else {
      <div class="comment-header">
        <div class="comment-status">
          <div class="comment-priority">
            <mat-icon class="icon" color="primary" [svgIcon]="comment.priority" />
            {{ "comments.priority." + comment.priority | translate }}
          </div>
          @let isDuplicated = isDuplicateComputed();
          <div [class.duplicated]="isDuplicated" class="comment-code">
            <mat-icon class="icon" [class.report-hidden]="!isDuplicated" svgIcon="report" />
            {{ comment.code }}
          </div>
        </div>
        @if (canManage()) {
          <div class="comment-menu">
            <button
              title="comment-menu-{{ comment.code }}"
              mat-icon-button
              type="button"
              [mat-menu-trigger-for]="commentMenu"
              (click)="stopProp($event)">
              <mat-icon class="icon" color="primary" svgIcon="menu-kebab" />
            </button>
          </div>
        }
      </div>
      @if (!isOnDm()) {
        <div class="comment-reference">
          <span>{{ reference() }}</span>
        </div>
      }
      <div class="comment-title">{{ comment.title }}</div>
      <div class="comment-paragraphs">
        @for (paragraph of comment.contents; track $index; let first = $first) {
          <!-- SPEC: Only the first paragraph is visible in reduce mode -->
          <div class="comment-paragraph" [class.visible]="expanded" [class.collapsible-content]="!first">
            {{ paragraph }}
          </div>
        }
      </div>
    }
    <div class="collapsible-content" [class.visible]="expanded">
      @if (!editMode && commentService.canAttachMedia && comment.medias?.length > 0) {
        <div class="info">
          <div class="key">{{ "front.attached-medias" | translate }}</div>
          <ul class="medias-panel value">
            @for (media of comment.medias; track $index) {
              <li>
                <div class="media-list-item">
                  <span class="media-link" (click)="openMedia($event, media.id, media.title)">
                    {{ media.title }}
                  </span>
                </div>
              </li>
            }
          </ul>
        </div>
      }
      <div class="info">
        <div class="key">{{ "front.status" | translate }}</div>
        <div class="value">{{ commentStatus[comment.responseType] ?? commentStatus["default"] }}</div>
      </div>
      <div class="info">
        <div class="key">{{ "front.type" | translate }}</div>
        <div class="value">{{ commentTypes[comment.commentType] ?? commentTypes["default"] }}</div>
      </div>
      @switch (comment.location) {
        @case (commentLocation.DM) {
          <div class="info">
            <div class="key">{{ "comments.infos.dmc" | translate }}</div>
            <div class="value">{{ comment.dmInfos.dmc | compactedDmc }}</div>
          </div>
          <div class="info">
            <div class="key">{{ "comments.infos.dmTitle" | translate }}</div>
            <div class="value">{{ comment.dmInfos.dmTitle }}</div>
          </div>
          <div class="info">
            <div class="key">
              {{ "comments.infos.isn" | translate }}, {{ "front.type" | translate }},
              {{ "loap.info.date" | translate }}
            </div>
            <div class="value">{{ comment.dmInfos.dmIssueInfos }}</div>
          </div>
        }
        @case (commentLocation.PM) {
          <div class="info">
            <div class="key">{{ "comments.infos.pmCode" | translate }}</div>
            <div class="value">{{ comment.pmInfos.pmCode }}</div>
          </div>
        }
        @case (commentLocation.PUB) {
          <div class="info">
            <div class="key">{{ "comments.infos.pubCode" | translate }}</div>
            <div class="value">{{ comment.pubInfos.pubCode }}</div>
          </div>
          <div class="info">
            <div class="key">{{ "comments.infos.pubTitle" | translate }}</div>
            <div class="value">{{ comment.pubInfos.verbatimText }}</div>
          </div>
        }
        @case (commentLocation.APP) {
          <div class="info">
            <div class="key">{{ "comments.infos.appName" | translate }}</div>
            <div class="value">{{ comment.appInfos.appName }}</div>
          </div>
          <div class="info">
            <div class="key">{{ "comments.infos.appVersion" | translate }}</div>
            <div class="value">{{ comment.appInfos.appVersion }}</div>
          </div>
        }
      }
    </div>
    <div class="comment-footer">
      <div class="comment-infos">
        <span>{{
          "tocItem.createdBy"
            | translate
              : {
                  author: comment.author || "Unknown user",
                  date: formattedDate,
                  rev: comment.revision
                }
        }}</span>
      </div>
      <div class="more">
        <span class="more-info" (click)="toggleExpansion($event)">
          {{ (expanded ? "actions.reduce" : "actions.expand") | translate }}
        </span>
      </div>
    </div>
  </div>
</mat-card>

<mat-menu #commentMenu="matMenu">
  <button mat-menu-item class="comment-edit" type="button" [disabled]="!canEdit()" (click)="startEdit()">
    <mat-icon color="primary" svgIcon="pencil" />
    {{ "notes.edit" | translate }}
  </button>
  <button mat-menu-item class="comment-delete" type="button" [disabled]="!canManage()" (click)="delete()">
    <mat-icon color="primary" svgIcon="delete" />
    {{ "actions.delete" | translate }}
  </button>
</mat-menu>
